import { render, staticRenderFns } from "./headerBanner.vue?vue&type=template&id=56fa55ca&scoped=true"
import script from "./headerBanner.vue?vue&type=script&lang=js"
export * from "./headerBanner.vue?vue&type=script&lang=js"
import style0 from "./headerBanner.vue?vue&type=style&index=0&id=56fa55ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa55ca",
  null
  
)

export default component.exports